import { DateTime } from 'luxon';

// This component handles multi-day events that can be across
// different months or different years
const MultidayStamp = ({ event }) => {
  const startDate = DateTime.fromISO(event.datetime, { setZone: true });
  const endDate = DateTime.fromISO(event.endTime, { setZone: true });

  if (startDate.year !== endDate.year) {
    return (
      <div className="-mt-1 shadow-md">
        <span className="text-xs">{startDate.toLocaleString(DateTime.DATE_MED)}</span>
        <span className="text-xs"> - </span>
        <span className="text-xs">{endDate.toLocaleString(DateTime.DATE_MED)}</span>
      </div>
    );
  }

  if (startDate.month !== endDate.month) {
    return (
      <div className="-mt-1 shadow-md">
        <span className="text-xs">{startDate.toFormat('LLL d')}</span>
        <span className="text-xs"> - </span>
        <span className="text-xs">{endDate.toFormat('LLL d')}</span>
      </div>
    );
  }

  return (
    <div className="-mt-1 shadow-md">
      <span className="text-xs">{startDate.toFormat('LLL d')}</span>
      <span className="text-xs"> - </span>
      <span className="text-xs">{endDate.toFormat('d')}</span>
    </div>
  );
};

const DateStamp = ({ event }) => {
  const time = DateTime.fromISO(event.datetime, { setZone: true });
  const now = DateTime.local().setZone(time.zoneName);

  const isToday = time.toISODate() === now.toISODate();
  const isTomorrow = time.toISODate() === now.plus({ days: 1 }).toISODate();

  const renderStamp = () => {
    if (event.multiDay) {
      return <MultidayStamp event={event} />;
    }
    if (isToday) {
      return <span className="text-xs font-semibold">Today</span>;
    }
    if (event.isOnNow) {
      return (
        <div className="text-base font-semibold leading-5">
          <span>On</span>
          <br />
          <span>Now</span>
        </div>
      );
    }
    return (
      <div className="-mt-1 shadow-md">
        <span className="text-xs">{time.toFormat('LLL')}</span>
        <br />
        <span className="-mt-2 text-2xl font-bold inline-block">{time.toFormat('d')}</span>
      </div>
    );
  };

  return (
    <div className="ml-0 rounded-r bg-gray-900 text-white px-3 h-12 leading-1 flex place-items-center justify-center uppercase flex-shrink-0">
      <div className="text-center">{renderStamp()}</div>
    </div>
  );
};

export default DateStamp;
